import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/unmprojectpositionproject/cecUnmProjectPositionProject/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/unmprojectpositionproject/cecUnmProjectPositionProject/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/unmprojectpositionproject/cecUnmProjectPositionProject/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/unmprojectpositionproject/cecUnmProjectPositionProject/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/unmprojectpositionproject/cecUnmProjectPositionProject/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/unmprojectpositionproject/cecUnmProjectPositionProject/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/unmprojectpositionproject/cecUnmProjectPositionProject/import',
      method: 'post',
      data: data
    })
  }
}
